import axios from "axios";
import { getApiUrl } from "@/Utils/api-url-helper";

export const namespaced = true;

export const state = {
  provider: null,
  isAuthenticated: false,
  token: null,
  data: {},
  isPremium: null,
};

export const mutations = {
  SET_LOGIN(state, payload) {
    state.provider = payload.provider;
    state.token = payload.token;
    state.isAuthenticated = true;
    state.data = payload;
    // Reset premium status on login - will be fetched fresh
    state.isPremium = null;
    // Keep auth info in localStorage
    window.localStorage.setItem("auth", JSON.stringify(state));
    window.localStorage.setItem("token", payload.token);
    window.localStorage.setItem("role", payload.roles[0].name);
  },
  LOGOUT(state) {
    state.provider = null;
    state.key = null;
    state.isAuthenticated = false;
    state.data = {};
    window.localStorage.setItem("auth", null);
    window.localStorage.setItem("token", null);
    window.localStorage.setItem("role", null);
    window.localStorage.removeItem("teacher_institutions");
    window.localStorage.removeItem("teacher_current_institution_id");
  },
  INITIALISE(state) {
    const authInfo = JSON.parse(window.localStorage.getItem("auth"));
    if (authInfo && authInfo.isAuthenticated) {
      state.provider = authInfo.provider;
      state.token = authInfo.token;
      state.isAuthenticated = true;
      state.data = authInfo.data;
      state.role = authInfo.role;
      // Reset premium status on initialization - will be fetched fresh
      state.isPremium = null;
    } else {
      window.localStorage.setItem("auth", JSON.stringify(state));
      window.localStorage.setItem("token", state.token);
      window.localStorage.setItem("token", state.role);
    }
  },
  SET_PREMIUM_STATUS(state, status) {
    state.isPremium = status;
  }
};

export const actions = {
  setLogin({ commit }, payload) {
    commit("SET_LOGIN", payload);
  },
  logout({ commit }) {
    commit("LOGOUT");
  },
  initialise({ commit }) {
    commit("INITIALISE");
  },
  fetchPremiumStatus({ commit }) {
    const apiBaseUrl = getApiUrl(import.meta.env.VITE_API_BASE_URL);
    axios.get(`${apiBaseUrl}/api/subscriptions/is-premium`, {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    })
      .then(response => {
        commit('SET_PREMIUM_STATUS', response.data.isPremium);
      })
      .catch(error => {
        console.error("Error fetching premium status:", error);
      });
  }
};
